module.exports = __webpack_public_path__ + "img/bnd_rnd_head_sku.prt.7d390bd1.jpg";